import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu as MenuIcon, X } from "lucide-react";
import { useAuth } from "../contexts/SupabaseAuthContect";
import { NavbarDropdown } from "./ui/NavbarDropdown";

export function Navbar() {
    const { user, role, logout } = useAuth();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <nav className="w-full bg-background/80 backdrop-blur-md border-b border-border relative z-50">
            <div className="max-w-7xl mx-auto px-6 py-4">
                <div className="flex justify-between items-center">
                    <Link to="/" className="text-xl font-bold text-pink-400">
                        Daisy Kirbukas
                    </Link>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center gap-4">
                        {user ? (
                            <NavbarDropdown />
                        ) : (
                            <>
                                <Link to="/login" className="text-pink-400 hover:text-fuchsia-200">
                                    Logi sisse
                                </Link>
                            </>
                        )}
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        className="md:hidden text-pink-400 hover:text-fuchsia-200 relative z-[60]"
                        aria-label="Toggle menu"
                        aria-expanded={mobileMenuOpen}
                    >
                        {mobileMenuOpen ? <X className="w-7 h-7" /> : <MenuIcon className="w-7 h-7" />}
                    </button>
                </div>

                {mobileMenuOpen && (
                    <div className="md:hidden absolute left-0 right-0 top-full bg-background/95 backdrop-blur-md border-b border-border shadow-lg z-[55]">
                        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-3">
                            {user ? (
                                <>
                                    <Link
                                        to="/profile"
                                        className="text-pink-400 hover:text-fuchsia-200 py-2"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        Profiil
                                    </Link>
                                    {role === "admin" && (
                                        <>
                                            <Link
                                                to="/stalls"
                                                className="text-pink-400 hover:text-fuchsia-200 py-2"
                                                onClick={() => setMobileMenuOpen(false)}
                                            >
                                                Boksid
                                            </Link>
                                            <Link
                                                to="/cashier"
                                                className="text-pink-400 hover:text-fuchsia-200 py-2"
                                                onClick={() => setMobileMenuOpen(false)}
                                            >
                                                Maksed
                                            </Link>
                                        </>
                                    )}
                                    <button
                                        onClick={() => {
                                            logout();
                                            setMobileMenuOpen(false);
                                        }}
                                        className="text-red-500 hover:text-red-400 py-2 text-left"
                                    >
                                        Logi välja
                                    </button>
                                </>
                            ) : (
                                <>
                                    <Link
                                        to="/login"
                                        className="text-pink-400 hover:text-fuchsia-200 py-2"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        Logi sisse
                                    </Link>
                                    <Link
                                        to="/contact"
                                        className="text-pink-400 hover:text-fuchsia-200 py-2"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        Kontakt
                                    </Link>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </nav>
    );
}
